module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "case-4"
    }
  }, [_c('h1', [_vm._v("Case 4")]), _vm._v(" "), _c('div', {
    staticClass: "section level21",
    attrs: {
      "id": "clinical-presentation-3"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-bottom": "6px",
      "letter-spacing": "1px",
      "padding-top": "28px",
      "font-weight": "bold",
      "text-indent": "0px"
    }
  }, [_vm._v("Clinical Presentation")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("A 40-year-old man presented with acute onset of severe lower abdominal pain, nausea and vomiting with a palpable mid-pelvic mass.")])]), _vm._v(" "), _c('div', {
    staticClass: "section level21",
    attrs: {
      "id": "radiological-findings-3"
    }
  }, [_c('p', {
    staticStyle: {
      "padding-bottom": "6px",
      "letter-spacing": "1px",
      "padding-top": "28px",
      "font-weight": "bold",
      "text-indent": "0px"
    }
  }, [_vm._v("Radiological Findings")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "4",
      "src": "media/4.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "15px",
      "padding-bottom": "10px",
      "text-align": "center"
    }
  }), _vm._v(" "), _c('ul', {
    staticStyle: {
      "list-style": "none",
      "padding-right": "95px",
      "padding-left": "110px",
      "margin-top": "0px"
    }
  }, [_c('li', [_c('p', {
    staticStyle: {
      "text-indent": "20px"
    }
  }, [_c('strong', [_vm._v("Enhanced Abdominal CT scan, axial (A, B, C) with coronal / sagittal reconstruction (D, E, F) images")]), _vm._v(" showing a sausage-shaped mid-pelvic mass with central area containing mesenteric fat and vessels indicating intussusception. Distal within this mass there is a well-defined fatty-density lesion (arrow images, C, E and F) representing a lipoma. Note proximal small bowel dilatation.")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px",
      "padding-top": "15px"
    }
  }, [_c('strong', [_vm._v("Diagnosis:")]), _vm._v(" Ileo-ileal Intussusception Secondary to a Lipoma")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4788824c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch010.vue
// module id = 93
// module chunks = 0